<div class="background" *ngIf="showBackground" @fadeInOut>
	<div #sidebar class="sidebar" *ngIf="showSidebar" @slideLeftSidebar>
		<div class="header">
			<div class="zk-w-full">
				<ng-content select="[header]"></ng-content>
				<p *ngIf="title">{{ title }}</p>
			</div>
			<span
				class="freud-icon freud-icon-md freud-icon-times"
				(click)="closeSidebar()"
			></span>
		</div>
		<freud-divider></freud-divider>
		<div class="sidebar__body">
			<ng-content select="[body]"></ng-content>
		</div>
			<div class="sidebar__footer">
				<ng-content select="[footer]"></ng-content>
			</div>
	</div>
</div>
